import React from "react";
import { useNavigate } from "react-router-dom";

import imageOne from "../../resource/meditate/guest-speaker/2.png";
import imageFour from "../../resource/meditate/guest-speaker/3.png";
import imageFive from '../../resource/meditate/external-retreat/5.png'

import imageSix from "../../resource/meditate/guest-speaker/5.png";
import imageThree from "../../resource/meditate/guest-speaker/1.png";
import TitleChnage from "../../Hook/TitleChnage";
import Calendar from '../Calendar/Calendar'
const GuestSpeaker = () => {
  TitleChnage("Guest Speaker");

  const navigate = useNavigate();
      const handleClick = (event) => {
          const pathMap = {
            organizerInstructions:'/organizerInstructions',
            organizerRequestForm:'/organizerRequestForm',
            guestSpeakerRequest:"/guestSpeakerRequest"
          };
      
          const path = event.currentTarget.id;
          const targetPath = pathMap[path];
      
          if (targetPath) {
            navigate(targetPath);
          }
        };
  return (
    <div className="guestSpeaker-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main dark-gold p-4 mt-4">Guest Speaker Retreats</h1>
      <h1 className="font-second dark-gold p-4 mt-4">With External Teachers</h1>

      <p className="mt-6 h4 p-4">
      The Bhaddeka Vihari Monastery and Meditation Centre offer the opportunity to organise and participate in retreats conducted by external teachers on the monastery premises.
      </p>
      <p className="mt-5 h4 p-4">
      To arrange a retreat with a guest teacher, preliminary discussions and a review by the monastery are required to ensure the retreat’s suitability and confirm the availability of space, in accordance with the Monastery’s standard review process.
      </p>
      <p className="mt-5 h4 p-4">
      It is important to note that all responsibilities—such as publicity, adherence to rules and regulations, scheduling, and ensuring the safety and well-being of the retreatants—lie with the retreat organizers.
      </p>
      <p className="mt-5 h4 p-4">
      The Bhaddeka Vihari Monastery and Meditation Centre solely provide the necessary premises for accommodation and facilities to hold the retreat.
      </p>
      <p className="mt-5 h4 p-4">
      For any information or inquiries regarding the retreat, please contact the retreat organizers directly, as the monastery is not involved in external retreat arrangements.
      </p>

      <h3 className="font-second dark-gold p-4 text-center mt-6">
        Retreats Calendar
      </h3>

      <div className="p-4 calander-box text-black align-item-center">
      <div className="calnder text-center mt-5">                <Calendar/></div>
      </div>


      <div className="btn-group2 mt-6">
        <img src={imageSix} alt="Right Top Image" width={300} id="organizerRequestForm" onClick={handleClick} className="curser-pointer" />
        <img src={imageFour} alt="Right Top Image" width={300} id="organizerInstructions" onClick={handleClick} className="curser-pointer"/>
      </div>

      <div className="mt-6 calander-box align-item-center p-4 text-center">
        <div className="c-details text-left">
          <h2 className="intro-text ">Contact Details</h2>
          <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
          <p className="font-p">Mr Gamini : 0422 069 359</p>
          <p className="font-p">WhatsApp : 0422 069 359</p>
          <p className="font-p">E-mail : info@bvp.org.au</p>
        </div>
        <div className="d-button">
        <img src={imageFive} alt="Right Top Image" width={300} id="guestSpeakerRequest" onClick={handleClick} className="curser-pointer" />
        </div>
      </div>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default GuestSpeaker;
